import { render, staticRenderFns } from "./facebook-comment.vue?vue&type=template&id=90d7e6d2&"
import script from "./facebook-comment.vue?vue&type=script&lang=js&"
export * from "./facebook-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports